import './indexPage.css';
import { setupApp } from "../app.ts";

main();

function main() {
    setupApp();
}

